// @ts-nocheck
import { Subject } from "rxjs";
import { a } from "../shared/globalState/a";
import { symbolsPredefined } from "../shared/shapes-predefined-collection/symbols";
import { ObjectTypes } from "../shared/enums";

export var dbUpdate$ = new Subject();

const databaseName = 'tomatDatabase';
const shapesTableName = 'shapesTable';
const textTableName = 'textTable';
const commandsTableName = 'commandsTable';
const zlcTableName = 'zlcTable';
const blockTableName = 'blockTable';
const dbVersion = 1;

const successUpdateMessage = '** database updated successfully **';

function initialize() {
    var request = indexedDB.open(databaseName, dbVersion);
    request.onerror = console.error;
    request.onupgradeneeded = function (event: IDBVersionChangeEvent) {
        let db = (event.target as IDBOpenDBRequest).result;

        try {
            db.createObjectStore(shapesTableName);
        } catch (error) {
            console.error(error);
        }
        try {
            db.createObjectStore(textTableName);
            
        } catch (error) {
            console.error(error);
        }
        try {
            db.createObjectStore(commandsTableName);
            
        } catch (error) {
            console.error(error);
        }
        try {
            db.createObjectStore(zlcTableName);
            
        }
        catch (error) {
            console.error(error);
        }
        try {
            db.createObjectStore(blockTableName);
        }
        catch (error) {
            console.error(error);
        }

        updateAliases();

        console.log('** database created successfully **');
    }
    request.onsuccess = function (event) {
        updateAliases();
        console.log(`** database request successful, database exists **`);
    }

}
function list() {
    var request = indexedDB.open(databaseName);
    request.onerror = console.error;
    request.onsuccess = function (event) {
        let db = (event.target as IDBOpenDBRequest).result;
        let transaction = db.transaction([shapesTableName, textTableName, commandsTableName], 'readonly');
        let shapesStore = transaction.objectStore(shapesTableName);
        let textStore = transaction.objectStore(textTableName);
        let commandsStore = transaction.objectStore(commandsTableName);
        let shapes = shapesStore.getAll();
        let text = textStore.getAll();
        let commands = commandsStore.getAll();
        shapes.onerror = console.error;
        shapes.onsuccess = function (event) {
            let shapes = (event.target as IDBOpenDBRequest).result;
            a.storedShapes$.next(shapes);
            db.close();
        }
        text.onsuccess = function (event) {
            let text = (event.target as IDBOpenDBRequest).result;
            a.storedText$.next(text);
            db.close();
        }
        commands.onsuccess = function (event) {
            let commands = (event.target as IDBOpenDBRequest).result;
            a.storedCommands$.next(commands);
            db.close();
        }
    }

}
function create(arrayOfObjects) {
    var request = indexedDB.open(databaseName, dbVersion);
    request.onerror = console.error;
    request.onsuccess = function (event) {
        let db = (event.target as IDBOpenDBRequest).result;
        let transaction = db.transaction([shapesTableName, textTableName, commandsTableName], 'readwrite');

        let shapesStore = transaction.objectStore(shapesTableName);
        let textStore = transaction.objectStore(textTableName);
        let commandsStore = transaction.objectStore(commandsTableName);

        if (Array.isArray(arrayOfObjects)) {
            for (const shape of arrayOfObjects) {
                let obj = shape.getObject();
                if (shape.type !== 'text') {
                    shapesStore.put(obj, `${shape.type}_${shape.id}`);

                }
                else if (shape.type === 'text') {
                    textStore.put(obj, `${shape.type}_${shape.id}`);
                }
            }
        }
        else {
            // в этом случае arrayOfObjects является объектом - на данный момент это означает, что там хранится объект списка комманд
            let commandList = arrayOfObjects;
            commandsStore.put(commandList, 0);
        }

        transaction.oncomplete = function (event) {
            /**
             * TODO: сделать удобный механизм отображения служебных сообщений
             */
            db.close();
            showMessageSuccess('Сохранение успешно выполнено ...');

            console.log(successUpdateMessage);
        }
        transaction.onerror = function (event) {
            db.close();
            showMessageError('Ошибка при сохранении ...')

            console.error('** database update failed **');
        }
    }
}


/**
 * Функция сохраняет в базу данных заранее подготовленную колекцию блоков по АВОК
 */
export function createAliases(aliasList) {
    
    var request = indexedDB.open(databaseName, dbVersion);
    request.onerror = console.error;
    request.onsuccess = function (event) {
        let db = (event.target as IDBOpenDBRequest).result;
        let transaction = db.transaction([blockTableName], 'readwrite');

        let blockStore = transaction.objectStore(blockTableName);

        for (const a of aliasList) {
            blockStore.put(a, a.code)
        }

        transaction.oncomplete = function (event) {
            db.close();
            showMessageSuccess('Загрузка коллекции блоков успешно выполнена...');

            console.log(successUpdateMessage);
        }
        transaction.onerror = function (event) {
            db.close();
            showMessageError('Ошибка при загрузке коллекции блоков...');

            console.error('** database update failed **');
        }
    }
}

/**
 * Функция загружает коллекцию блоков из базы данных 
 * и передаёт блоки дальше, обычно в компонент Svelte
 */
export function updateAliases() {

    var request = indexedDB.open(databaseName, dbVersion);
    request.onerror = console.error;
    request.onsuccess = function (event) {
        let db = (event.target as IDBOpenDBRequest).result;
        let transaction = db.transaction([blockTableName],'readonly');
        let blockStore = transaction.objectStore(blockTableName);
        let aliases = blockStore.getAll();
        aliases.onerror = console.error;
        aliases.onsuccess = function (event) {
            let aliases = (event.target as IDBOpenDBRequest).result;
            
            a.storedAliases$.next(aliases);
            db.close();
        }
    }
}

function showMessageSuccess(message) {
    showMessage(message, 'green');
}

function showMessageError(message) {
    showMessage(message, 'red');
}

function showMessage(message,color) {
    a.showAlertDialog$.next({
        title: "",
        message: message,
        isVisible: true
    });
}

function retrieve(id) {

}
function update(id, obj) {

}
function del(id) {

}
function clear() {
    var request = indexedDB.open(databaseName);
    request.onerror = console.error;
    request.onsuccess = function (event) {
        let db = (event.target as IDBOpenDBRequest).result;
        let transaction = db.transaction([shapesTableName, textTableName], 'readwrite');
        let shapesStore = transaction.objectStore(shapesTableName);
        let textStore = transaction.objectStore(textTableName);
        shapesStore.clear();
        textStore.clear();
        transaction.oncomplete = function (event) {
            db.close();
            console.log('** database cleared successfully **');
        }
    }
}


/**
 * Функция сохраняет блок в коллекции блоков с быстрым поиском
 */
export function saveToBlockCollection(block) {
    
    if (block.type !== ObjectTypes.block) {
        console.error(`!! Переданная в функцию 'saveToBlockCollection' фигура не является блоком`);
        return;
    }

    console.group(`** saveToBlockCollection **`);
    console.log(block);
    console.groupEnd();

    var request = indexedDB.open(databaseName, dbVersion);
    request.onerror = console.error;
    request.onsuccess = function (event) {
        let db = (event.target as IDBOpenDBRequest).result;
        let transaction = db.transaction([blockTableName], 'readwrite');
        let blockStore = transaction.objectStore(blockTableName);
        let obj = block.getObject();
        blockStore.put(obj, `${block.data.code}`);
        

        transaction.oncomplete = function (event) {
            db.close();
            showMessageSuccess("Блок успешно добавлен в коллекцию ...");
            console.log(successUpdateMessage);
            dbUpdate$.next(true);
            updateAliases();
        }
        transaction.onerror = function (event) {
            db.close();
            showMessageError("Ошибка при добавлении блока в коллекцию...");
            console.error('** database update failed **');
            dbUpdate$.next(false);
        }
    }
}

export function addPredefinedBlocks() {
    
    var symbols = symbolsPredefined;

    var s = performance.now();

    var request = indexedDB.open(databaseName, dbVersion);
    request.onsuccess = function (event) {
        let db = (event.target as IDBOpenDBRequest).result;
        let transaction = db.transaction([blockTableName], 'readwrite');
        let blockStore = transaction.objectStore(blockTableName);

        symbols.forEach(s => {
            let obj = s;
            blockStore.put(obj, `${obj.data.code}`);
        });

        transaction.oncomplete = function (event) {
            db.close();
            showMessageSuccess("Блоки из предопределённой коллекции успешно добавлены ...")
            console.log(successUpdateMessage);
        }

        transaction.onerror = function (event) {
            db.close();
            showMessageError("Ошибка при добавлении блока в коллекцию ...");
            console.error(`** database update failed **`);
            dbUpdate$.next(false);
        }
    }


    var e = performance.now();
    console.log(`** Predefined blocks added on ${e-s} ms`);
}

/**
 * Функция извлекает блок из базы данных
 */
export function retrieveFromBlockCollection(code) {
    
    var request = indexedDB.open(databaseName, dbVersion);
    request.onerror = console.error;
    request.onsuccess = function (event) {
        let db = (event.target as IDBOpenDBRequest).result;
        let transaction = db.transaction([blockTableName], 'readonly');
        let blockStore = transaction.objectStore(blockTableName);
        let block = blockStore.get(code);
        block.onerror = console.error;
        block.onsuccess = function (event) {
            let block = (event.target as IDBOpenDBRequest).result;
            a.retrieveAlias$.next(block);
            db.close();
            
        }
    }
}

export { initialize, list, create, retrieve, update, del, clear }